var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000059270853570248238300000003234259647941611940_);fill:url(#SVGID_00000029016407879895599610000008645649390663805854_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000023248461894955117430000003422408545615525035_);fill:url(#SVGID_00000144317079914831034510000006939783912831830687_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000053508202580160585490000014346113189666280605_);fill:url(#SVGID_00000112621559273233279670000016126242447366900876_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000182521395751124890590000001012983096816053146_);fill:url(#SVGID_00000013186483481874739380000017718665507108747953_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000115483010150604933040000007009840445083647874_);fill:url(#SVGID_00000173128762508378959620000008240753339416494494_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000065068731108741335850000014384810360233443972_);fill:url(#SVGID_00000173160102218848325010000016503092956515841430_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000158728027800237835310000006598251465390378399_);fill:url(#SVGID_00000087375484671134092060000010172956990545932196_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000013909521309985533290000007807246730794377138_);fill:url(#SVGID_00000060024735853472550560000008253441319163304356_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000035503744368670535910000007912372887020393395_);fill:url(#SVGID_00000052790524587491107750000004248144350558389695_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000135657210043568944080000012986694561570906777_);fill:url(#SVGID_00000006677161554132575130000017114807554694421120_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000034791093521515240130000012269709891744065922_);fill:url(#SVGID_00000075882854150461417580000004277307989045627789_);}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000147912049145977779280000014416322545726685568_);fill:url(#SVGID_00000176024217161389568780000001001154429688749971_);}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000103250848324988484100000011437303564343548807_);fill:url(#SVGID_00000176033250291962701630000011013359247375126676_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M139,13.8c-54.4,3-95.2,41.1-97,90.8c0,1.3-0.1,2.7-0.1,4v0.3c0,55.9,39.6,98.6,46.3,105.5l4.7,30.3l-1,39 c0.1,1.9,1.5,3.3,3.3,3.5c0.1,0,0.3,0,0.4,0h0c0.1,0,0.1,0,0.2,0c2.1-0.1,3.7-1.9,3.6-4l1-39.4L95.6,212c-0.1-0.8-0.5-1.6-1.1-2.1 c-0.5-0.5-47-46.5-44.9-105c1.7-46.4,38.6-80.7,89.8-83.5C187,18.7,227.6,52,230,95.5c0.1,2-0.3,7.7-0.5,11.2l-0.2,3.2 c0.5,14,5.9,22.9,20.9,43.1l-13.4,14.1c-0.6,0.6-1,1.5-1,2.3l-0.9,12l-7.2,9c-1,1.3-1.1,3.1-0.2,4.5l3.5,5.1l-2.6,25.3l-33.2,2.8 c-0.2,0-0.3,0-0.5,0.1c-16.4,3.6-19.3,22.3-19.5,23.1c0,0.2,0,0.4,0,0.5l-0.3,31.5c0,2.1,1.6,3.8,3.7,3.8h0h0 c2.1,0,3.8-1.7,3.8-3.8l0.3-31.2c0.3-1.8,3-14.1,13.3-16.5l36-3.1c1.8-0.2,3.2-1.6,3.4-3.4l3.1-29.8c0.1-0.9-0.1-1.8-0.7-2.5 l-2.7-3.9l6.2-7.7c0.5-0.6,0.8-1.3,0.8-2.1l0.9-11.8l14.7-15.5c1.3-1.3,1.4-3.4,0.3-4.9c-15.7-21.1-20.9-28.9-21.4-41.1l0.2-2.7 c0.4-5.1,0.7-9.8,0.5-12.1c-2.5-46-43.7-81.5-92.9-81.5C142.7,13.6,140.9,13.7,139,13.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083779834911492393890000007210917303055113877_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008833475976268926120000002245017662924752046_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 302.5745,
    x2: 2.9835,
    y2: 302.5745,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.9,
    y: 13.6,
    style: {
      clipPath: "url(#SVGID_00000083779834911492393890000007210917303055113877_)",
      fill: "url(#SVGID_00000008833475976268926120000002245017662924752046_)"
    },
    width: 217.3,
    height: 273.7
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000008131823211547941950000006170745496348329857_",
    d: "M162.8,167.4l-43.4,0.2c-2.1,0-3.8,1.7-3.8,3.8 c0,1.7,1.2,3.2,2.7,3.6c0.3,0.1,0.7,0.1,1.1,0.1l43.4-0.2c2.1,0,3.8-1.7,3.8-3.8C166.6,169.1,164.9,167.4,162.8,167.4 C162.8,167.4,162.8,167.4,162.8,167.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002363942507052753140000002108503906028559289_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008131823211547941950000006170745496348329857_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117670190582479803920000000571959745550084248_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 302.4592,
    x2: 2.9835,
    y2: 302.4592,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 115.6,
    y: 167.4,
    style: {
      clipPath: "url(#SVGID_00000002363942507052753140000002108503906028559289_)",
      fill: "url(#SVGID_00000117670190582479803920000000571959745550084248_)"
    },
    width: 51,
    height: 7.7
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000143605285060216000030000016444577101236462002_",
    d: "M119.7,178.1c-2.1,0-3.8,1.7-3.8,3.8 c0,1.7,1.2,3.2,2.7,3.6c0.3,0.1,0.7,0.1,1.1,0.1l43.4-0.2c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8L119.7,178.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120544779069632649080000013548294790979938486_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143605285060216000030000016444577101236462002_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065072891085299054740000010394633681240538515_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 302.4622,
    x2: 2.9835,
    y2: 302.4622,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 115.9,
    y: 177.9,
    style: {
      clipPath: "url(#SVGID_00000120544779069632649080000013548294790979938486_)",
      fill: "url(#SVGID_00000065072891085299054740000010394633681240538515_)"
    },
    width: 51,
    height: 7.8
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000124881697793310979540000008027717616014716588_",
    d: "M162.7,156.4c-2.1,0-3.8,1.7-3.8,3.8l0.1,19.7l-6.2,4.6 c-0.2,0.1-4,3.4-11.7,3.5c-7.7,0-11.6-3.2-11.7-3.3c-0.1-0.1-0.2-0.2-0.3-0.2l-5.9-4.3l-0.1-19.7c0-2.1-1.7-3.8-3.8-3.8 c-2.1,0-3.8,1.7-3.7,3.8l0.2,21.6c0,1.2,0.6,2.3,1.6,3l7.4,5.4c0.8,0.6,3.4,2.7,8,3.9c2.4,0.7,5.3,1.2,8.7,1.2 c9.9,0,15.4-4.3,16.6-5.2l7.3-5.4c1-0.7,1.5-1.9,1.5-3.1l-0.2-21.6C166.5,158.1,164.8,156.4,162.7,156.4 C162.7,156.4,162.7,156.4,162.7,156.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092436781005099136190000018255096472425714617_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124881697793310979540000008027717616014716588_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098222034439225093900000011924942429385688975_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 302.4587,
    x2: 2.9835,
    y2: 302.4587,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 156.4,
    style: {
      clipPath: "url(#SVGID_00000092436781005099136190000018255096472425714617_)",
      fill: "url(#SVGID_00000098222034439225093900000011924942429385688975_)"
    },
    width: 51.2,
    height: 39.1
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116203235799464965690000007157641124553467037_",
    d: "M123,154.8c0-0.2-0.1-0.6-0.1-1.1 c-0.5-3.5-1.5-11.7-5.9-16.8c-14.6-16.1-13.4-27.1-13.4-27.1c0-0.2,0-0.4,0-0.6c-0.1-20.5,16.5-37.3,37-37.4c3.6,0,7,0.5,10.3,1.4 c15.5,4.4,27,18.7,27,35.6c0,0.2,0,0.4,0,0.6c0,0.1,1.3,11-13.2,27.4c-4.2,5.1-5.2,13.3-5.6,16.8c-0.1,0.5-0.1,0.9-0.1,1 c-0.1,0.5-0.2,1.2-0.2,1.8l-35.6,0.2C123.2,156,123.1,155.3,123,154.8 M140.6,64.3C116,64.4,96.1,84.5,96.1,109 c-0.2,2.4-0.6,15.4,15.2,32.9c2.8,3.3,3.7,9.9,4,12.8c0.1,0.8,0.2,1.5,0.3,1.8c0.1,0.5,0.1,2.2-0.1,3.6c-0.1,1.1,0.3,2.1,1,2.9 c0.5,0.5,1.1,0.9,1.8,1.1c0.3,0.1,0.7,0.1,1,0.1l43.4-0.2c1.1,0,2.1-0.5,2.8-1.2c0.7-0.8,1.1-1.9,1-2.9c-0.1-1.2-0.2-3.1-0.1-3.6 c0.1-0.3,0.2-0.9,0.3-1.8c0.3-2.8,1.1-9.5,3.9-12.7c15.8-17.7,15.3-30.7,15-33.1c-0.2-24.5-20.3-44.4-44.8-44.4 C140.7,64.3,140.7,64.3,140.6,64.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022525518247684773220000011263564255171430786_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116203235799464965690000007157641124553467037_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162337127071725698100000009433239040896637064_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 302.4559,
    x2: 2.9835,
    y2: 302.4559,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 64.3,
    style: {
      clipPath: "url(#SVGID_00000022525518247684773220000011263564255171430786_)",
      fill: "url(#SVGID_00000162337127071725698100000009433239040896637064_)"
    },
    width: 90.8,
    height: 99.9
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000090989353327409201240000009963492036659140764_",
    d: "M140.7,79c-8.2,0-15.9,3.3-21.7,9.1 c-5.8,5.8-8.9,13.5-8.9,21.8c0,1.7,1.2,3.2,2.7,3.6c0.3,0.1,0.7,0.1,1.1,0.1c2.1,0,3.8-1.7,3.8-3.8c0-6.2,2.4-12,6.7-16.4 c4.4-4.4,10.2-6.8,16.3-6.9c2.1,0,3.8-1.7,3.8-3.8S142.8,79,140.7,79C140.7,79,140.7,79,140.7,79"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041293880963981869610000012537713808985847434_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090989353327409201240000009963492036659140764_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129176922103887485950000005678471422835107225_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 302.2903,
    x2: 2.9835,
    y2: 302.2903,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 110.1,
    y: 79,
    style: {
      clipPath: "url(#SVGID_00000041293880963981869610000012537713808985847434_)",
      fill: "url(#SVGID_00000129176922103887485950000005678471422835107225_)"
    },
    width: 34.4,
    height: 34.6
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000138548493606552304730000002613658252617922194_",
    d: "M138.3,37.1l0.1,18.3c0,1.7,1.2,3.2,2.7,3.6 c0.3,0.1,0.7,0.1,1.1,0.1c2.1,0,3.8-1.7,3.8-3.8l-0.1-18.3c0-2.1-1.7-3.8-3.8-3.8C140,33.3,138.3,35,138.3,37.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059301237986472579930000008056227594482273937_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138548493606552304730000002613658252617922194_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088842574566355142180000006127278496814381750_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 302.4709,
    x2: 2.9835,
    y2: 302.4709,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.3,
    y: 33.3,
    style: {
      clipPath: "url(#SVGID_00000059301237986472579930000008056227594482273937_)",
      fill: "url(#SVGID_00000088842574566355142180000006127278496814381750_)"
    },
    width: 7.7,
    height: 25.9
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029733334282794047020000018090901037597913534_",
    d: "M189.5,55.3l-12.9,13c-1.5,1.5-1.5,3.9,0,5.3 c0.5,0.5,1,0.8,1.6,0.9c1.3,0.4,2.7,0,3.7-1l12.9-13c1.5-1.5,1.5-3.9,0-5.3c-0.7-0.7-1.7-1.1-2.7-1.1 C191.2,54.2,190.2,54.6,189.5,55.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151507520726599599880000005236912026573080981_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029733334282794047020000018090901037597913534_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088129279820324819080000003475802004771039157_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 303.002,
    x2: 2.9835,
    y2: 303.002,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 175.1,
    y: 54.2,
    style: {
      clipPath: "url(#SVGID_00000151507520726599599880000005236912026573080981_)",
      fill: "url(#SVGID_00000088129279820324819080000003475802004771039157_)"
    },
    width: 21.2,
    height: 20.8
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000010992897196237977960000009645997442235140790_",
    d: "M212.8,104.4l-18.3,0.1c-2.1,0-3.8,1.7-3.8,3.8 c0,1.7,1.2,3.2,2.7,3.6c0.3,0.1,0.7,0.1,1.1,0.1l18.3-0.1c2.1,0,3.8-1.7,3.8-3.8C216.6,106.1,214.9,104.4,212.8,104.4 C212.8,104.4,212.8,104.4,212.8,104.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098931621235094582220000006077932511477570742_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010992897196237977960000009645997442235140790_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059998342520414294510000011763527274218483861_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 303.2206,
    x2: 2.9835,
    y2: 303.2206,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 190.7,
    y: 104.4,
    style: {
      clipPath: "url(#SVGID_00000098931621235094582220000006077932511477570742_)",
      fill: "url(#SVGID_00000059998342520414294510000011763527274218483861_)"
    },
    width: 25.9,
    height: 7.6
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000090261052890307395980000013917722504033749411_",
    d: "M176.2,142.7c-1.5,1.5-1.5,3.9,0,5.4l13,12.9 c0.5,0.5,1,0.8,1.6,1c1.3,0.4,2.7,0,3.7-1c1.5-1.5,1.5-3.9,0-5.3l-13-12.9c-0.7-0.7-1.7-1.1-2.7-1.1 C177.9,141.6,177,142,176.2,142.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122712067853421679330000017666274579662522267_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090261052890307395980000013917722504033749411_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039116449587802386790000001617896692518316680_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 302.9984,
    x2: 2.9835,
    y2: 302.9984,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 174.8,
    y: 141.6,
    style: {
      clipPath: "url(#SVGID_00000122712067853421679330000017666274579662522267_)",
      fill: "url(#SVGID_00000039116449587802386790000001617896692518316680_)"
    },
    width: 21.3,
    height: 20.7
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000025444446668127084010000006283913767691358626_",
    d: "M101.8,142.4l-12.9,13c-1.5,1.5-1.5,3.9,0,5.3 c0.5,0.5,1,0.8,1.6,0.9c1.3,0.4,2.7,0,3.7-1l12.9-13c1.5-1.5,1.5-3.9,0-5.3c-0.7-0.7-1.7-1.1-2.7-1.1 C103.6,141.3,102.6,141.7,101.8,142.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163056730704603967020000000406718602298052491_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025444446668127084010000006283913767691358626_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018925386898818133690000014101213836214763140_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 301.9347,
    x2: 2.9835,
    y2: 301.9347,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 141.3,
    style: {
      clipPath: "url(#SVGID_00000163056730704603967020000000406718602298052491_)",
      fill: "url(#SVGID_00000018925386898818133690000014101213836214763140_)"
    },
    width: 21.2,
    height: 20.8
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000120560443817980423680000010396584000408235695_",
    d: "M89.3,104L71,104.1c-2.1,0-3.8,1.7-3.8,3.8 c0,1.7,1.2,3.2,2.7,3.6c0.3,0.1,0.7,0.1,1,0.1l18.3-0.1c2.1,0,3.8-1.7,3.8-3.8C93.1,105.7,91.4,104,89.3,104 C89.3,104,89.3,104,89.3,104"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065044884513845016340000003822685616976555929_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120560443817980423680000010396584000408235695_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089554357282984433340000004965489995332249254_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 301.7162,
    x2: 2.9835,
    y2: 301.7162,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 67.2,
    y: 104,
    style: {
      clipPath: "url(#SVGID_00000065044884513845016340000003822685616976555929_)",
      fill: "url(#SVGID_00000089554357282984433340000004965489995332249254_)"
    },
    width: 25.9,
    height: 7.6
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000064312649333643387040000002380998936905497242_",
    d: "M89.2,55.1c-1.5,1.5-1.5,3.9,0,5.3l13,12.9 c0.5,0.5,1,0.8,1.6,1c1.3,0.4,2.7,0,3.7-1c1.5-1.5,1.5-3.9,0-5.3l-13-12.9c-0.7-0.7-1.7-1.1-2.7-1.1C90.9,54,89.9,54.4,89.2,55.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020381173847804586410000011316155994842029972_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064312649333643387040000002380998936905497242_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160874134974816890600000004316445803828181411_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.0165,
    y1: 301.9383,
    x2: 2.9835,
    y2: 301.9383,
    gradientTransform: "matrix(0 82.1177 82.1177 0 -24696.1074 160.3894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 87.7,
    y: 54,
    style: {
      clipPath: "url(#SVGID_00000020381173847804586410000011316155994842029972_)",
      fill: "url(#SVGID_00000160874134974816890600000004316445803828181411_)"
    },
    width: 21.3,
    height: 20.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagine);
export default __webpack_public_path__ + "static/media/imagine.a5b948917c81df42101e209a20a91bde.svg";
export { ForwardRef as ReactComponent };